import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const GalleryUIAction = Object.freeze({
  initial: "Initial",
});

export const GetImageStatus = Object.freeze({
  initial: "Initial",
  ongoing: "Ongoing",
  noImages: "NoImages",
  error: "Error",
});

export const GetMoreImageStatus = Object.freeze({
  initial: "Initial",
  ongoing: "Ongoing",
  error: "Error",
  noMoreImages: "NoMoreImages",
});

const initialState = {
  action: GalleryUIAction.initial,
  getImageStatus: GetImageStatus.initial,
  getMoreImageStatus: GetMoreImageStatus.initial,
  errorMessage: "",
  isInitDone: false,
  images: [],
  imagesCount: 0,
  showImageViewer: false,
  viewerImageIndex: 0,
  showSingleImageViewer: false,
  singleImageUrl: "",
};

export const createGallerySlice = (mediaRepository) => {
  return createSlice({
    name: "gallery",
    initialState,
    reducers: {
      resetState: () => initialState,
      appendImages: (state, action) => {
        const image = action.payload;
        const newList = [...image, ...state.images];
        state.images = newList;
        state.imagesCount = state.images.length;
      },
      showPhotoViewer: (state, action) => {
        const imageItem = action.payload;
        const imageId = imageItem.id;
        const index = state.images.findIndex((obj) => obj.id === imageId);
        console.log("Selected Index", index);
        if (index > -1) {
          if (index === 0) {
            state.showImageViewer = true;
          } else {
            state.viewerImageIndex = index;
            state.showImageViewer = true;
          }
        } else {
          // Image Cannot found
          // View single image
          state.singleImageUrl = imageItem.imageUrl;
          state.showSingleImageViewer = true;
        }
      },
      hidePhotoViewer: (state, action) => {
        state.showImageViewer = false;
        state.showSingleImageViewer = false;
        state.viewerImageIndex = 0;
      },
      photoViewerSetIndex: (state, action) => {
        const index = action.payload.index;
        state.viewerImageIndex = index;
      },
    },
    extraReducers: (builder) => {
      builder
        // Get Initial Images
        .addCase(getInitialImages.pending, (state) => {
          state.getImageStatus = GetImageStatus.ongoing;
        })
        .addCase(getInitialImages.fulfilled, (state, action) => {
          const result = action.payload;
          state.images = [...result.images];
          state.imagesCount = state.images.length;
          state.isInitDone = true;
          state.getImageStatus =
            state.images.length === 0
              ? GetImageStatus.noImages
              : GetImageStatus.initial;
        })
        .addCase(getInitialImages.rejected, (state, action) => {
          const status = action.payload?.status ?? GetImageStatus.initial;
          const message = action.payload?.message ?? "";
          if (status === GetImageStatus.error) {
            state.errorMessage = message;
            state.getImageStatus = status;
          }
        })

        // Get More Images
        .addCase(getMoreImages.pending, (state) => {
          state.getMoreImageStatus = GetMoreImageStatus.ongoing;
        })
        .addCase(getMoreImages.fulfilled, (state, action) => {
          const result = action.payload;
          state.images = [...state.images, ...result.images];
          state.imagesCount = state.images.length;
          state.getMoreImageStatus =
            result.images.length === 0
              ? GetMoreImageStatus.noMoreImages
              : GetMoreImageStatus.initial;
        })
        .addCase(getMoreImages.rejected, (state, action) => {
          const status = action.payload?.status ?? GetMoreImageStatus.initial;
          const message = action.payload?.message ?? "";
          if (status === GetMoreImageStatus.error) {
            state.errorMessage = message;
            state.getMoreImageStatus = status;
          }
        });
    },
  });
};

export const getInitialImages = createAsyncThunk(
  "gallery/getInitialImages",
  async (data, { getState, rejectWithValue, extra }) => {
    const state = getState().gallery;
    const chatState = getState().chat;

    const chatChannelId = chatState.chatData.id;
    const mediaRepository = extra.mediaRepository;

    if (state.isInitDone) {
      return rejectWithValue({
        status: GetImageStatus.done,
        message: "Initial Images already loaded",
      });
    } else {
      const result = await mediaRepository.getChatImages({
        skip: state.images.length,
        chatChannelId,
      });
      if (result.success) {
        return result;
      } else {
        return rejectWithValue({
          status: GetImageStatus.error,
          message: result.message,
        });
      }
    }
  }
);

export const getMoreImages = createAsyncThunk(
  "gallery/getMoreImages",
  async (data, { getState, rejectWithValue, extra }) => {
    console.log("Get More Images");
    const state = getState().gallery;
    const chatState = getState().chat;

    const chatChannelId = chatState.chatData.id;
    const mediaRepository = extra.mediaRepository;

    const result = await mediaRepository.getChatImages({
      skip: state.images.length,
      chatChannelId,
    });
    if (result.success) {
      console.log("GET MORE IMAGES RESUKT", result);
      return result;
    } else {
      console.log("GET MORE IMAGES FAILED", result);
      return rejectWithValue({
        status: GetMoreImageStatus.error,
        message: result.message,
      });
    }
  }
);
